import { router } from '@inertiajs/react'
import { UserCog, X } from 'lucide-react'
import { Button } from '@/components/ui/Button'
import { godModeImpersonations } from '@/routeHelpers'
import type { TrueUser } from '@/types/shared'

interface ImpersonationBannerProps {
  trueUser: TrueUser
}

export function ImpersonationBanner({ trueUser }: ImpersonationBannerProps) {
  const handleStopImpersonating = () => {
    router.delete(godModeImpersonations.destroy.path())
  }

  return (
    <div className="bg-amber-500 text-amber-950 px-4 py-2 flex items-center justify-between">
      <div className="flex items-center gap-2">
        <UserCog className="size-4" />
        <span className="text-sm font-medium">
          Impersonating as this user. You are logged in as {trueUser.full_name} ({trueUser.email}).
        </span>
      </div>
      <Button
        variant="ghost"
        size="sm"
        onClick={handleStopImpersonating}
        className="cursor-pointer text-amber-950 hover:bg-amber-600 hover:text-amber-950 gap-1.5"
      >
        <X className="size-4" />
        Stop Impersonating
      </Button>
    </div>
  )
}
